

export default {
    name: "ESGRiskRating",

    props: {
        esgData: {
            type: Object,
            default: () => {},
        }
    },

    computed: {
        esgRiskLevel() {
            if (!this.esgData || !this.esgData.esgRiskRating) {
                return '';
            }
            const rating = this.esgData.esgRiskRating;
            if (rating.startsWith('A')) {
                return this.$t('component.share.esg.excellent');
            } else if (rating.startsWith('B')) {
                return this.$t('component.share.esg.good');
            } else if (rating.startsWith('C')) {
                return this.$t('component.share.esg.medium');
            } else if (rating.startsWith('D')) {
                return this.$t('component.share.esg.poor');
            } else {
                return ''
            }
        },
        esgColorClass() {
            if (!this.esgData || !this.esgData.esgRiskRating) {
                return 'purple-500';
            }
            const rating = this.esgData.esgRiskRating;
            if (rating.startsWith('A')) {
                return 'blue-500';
            } else if (rating.startsWith('B')) {
                return 'blue-300';
            } else if (rating.startsWith('C')) {
                return 'purple-500';
            } else if (rating.startsWith('D')) {
                return 'red-300';
            } else {
                return 'purple-500'
            }
        },
    },
}
